import React from 'react'
import { css, cx } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'

const horizontalRuleCss = css`
  margin: 0;
  padding-bottom: 10px;
  border: 0;
  border-top: 1px solid ${theme.color.neutral30};
`

export function HorizontalRule({ className }: { readonly className?: string }) {
  return <hr className={cx(horizontalRuleCss, className)} />
}
